<html>
<body style="background: #f0fdff; overflow-y: scroll;">
<div>
    <div>
        <p style="font-size: 32px; letter-spacing: -0.8px; padding: 20px;color: #424242;padding-bottom:0px; ">CSV Report History</p>
        <p style="padding: 20px;
        padding-top: 0;
        color: #424242;
        font-size: 20px;
        letter-spacing: -0.8px;
        width: 50%;"> This page keeps track of upload results for DR Horton Myrtle. Click a button below to view a summary for the related date. </p>
            <div style="padding:16px;">
                <mat-chip-list aria-label="Filter Selection">
                    <mat-chip (click)="loadReports(908)" >DR Horton KNX</mat-chip>
                    <mat-chip (click)="loadReports(1327)" >DR Horton MYR</mat-chip>
                    <mat-chip (click)="loadReports(980)" >DR Horton NOOG</mat-chip>
                    <mat-chip (click)="loadReports(1458)" >DR Horton South RDU</mat-chip>
                    <mat-chip (click)="loadReports(1937)" >DR Horton Indy</mat-chip>
                    <mat-chip (click)="loadReports(905)" >DR Horton GRV</mat-chip>
                    <mat-chip (click)="loadReports(39)" >True</mat-chip>
                    <mat-chip (click)="loadReports(1401)" >DR Horton Cincinnati</mat-chip>
                </mat-chip-list>
            </div>

            <button *ngIf="canSeeIDtool" (click)="openToolInNewTab()">ID Tool</button>
    </div>

    <div *ngFor="let item of data; let i = index" style="margin-bottom: 8px;">
        <button type="button" class="collapsible" (click)="toggleContent(i)" *ngIf="!item.reportinfo.updated">
            <span style="font-size: 20px; line-height: 3em; font-weight: 800; letter-spacing: -0.8px;">
                {{item.date_created.substring(0,10)}}
            </span>
            <span style="margin-left: 2em; font-size: 20px; line-height: 3em; font-weight: 200;">
                Addresses processed: {{item.reportinfo.address_does_not_exist.length + item.reportinfo.qi_date_updated.length + item.reportinfo.qi_job_added.length + item.reportinfo.skipped_marked_complete.length + item.reportinfo.skipped_on_for_today.length + item.reportinfo.skipped_same_date_as_csv.length + item.reportinfo.skipped_verified.length + (item.reportinfo.qi_followup_added?.length || 0) + (item.reportinfo.qi_followup_added_no_qi?.length || 0) + (item.reportinfo.followup_date_updated?.length || 0) + (item.reportinfo.qi_job_error?.length || 0)}}
            </span>
            <span style="float: right;font-size: 32px;">
                {{expanded[i] ? '-' : '+'}}
            </span>
        </button>
        <div class="content" [style.display]="expanded[i] ? 'block' : 'none'" *ngIf="!item.reportinfo.updated">
            <div style="margin-top: 16px; font-size: 20px;">
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    New Addresses: <span>{{item.reportinfo.address_does_not_exist.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.address_does_not_exist">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Date Updated: <span>{{item.reportinfo.qi_date_updated.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.qi_date_updated">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record.street_address}}: {{record.old_schedule_date.substring(5,10).replace('-', '/')}} => {{record.new_schedule_date.substring(5,10)}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Job Added: <span>{{item.reportinfo.qi_job_added.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.qi_job_added">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record.street_address}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Complete: <span>{{item.reportinfo.skipped_marked_complete.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_marked_complete">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Day Of: <span>{{item.reportinfo.skipped_on_for_today.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_on_for_today">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    CSV Date: <span>{{item.reportinfo.skipped_same_date_as_csv.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_same_date_as_csv">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Verified: <span>{{item.reportinfo.skipped_verified.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_verified">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            {{record}}
                        </p>
                    </div>
                </div>
                <ng-container *ngIf="item.reportinfo.qi_followup_added">
                    <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                        QI Follow Up Added: <span>{{item.reportinfo.qi_followup_added.length}}</span>
                    </p>
                    <div style="font-size: 16px; padding: 12px;">
                        <div *ngFor="let record of item.reportinfo.qi_followup_added">
                            <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                                {{record.street_address}}
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.reportinfo.qi_followup_added_no_qi">
                    <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                        QI Follow Up (No QI Found): <span>{{item.reportinfo.qi_followup_added_no_qi.length}}</span>
                    </p>
                    <div style="font-size: 16px; padding: 12px;">
                        <div *ngFor="let record of item.reportinfo.qi_followup_added_no_qi">
                            <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                                {{record.street_address}}
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.reportinfo.followup_date_updated">
                    <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                        Follow Up Date Updated: <span>{{item.reportinfo.followup_date_updated.length}}</span>
                    </p>
                    <div style="font-size: 16px; padding: 12px;">
                        <div *ngFor="let record of item.reportinfo.followup_date_updated">
                            <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                                {{record.street_address}}: {{record.old_schedule_date?.substring(5,10)?.replace('-', '/')}} => {{record.new_schedule_date?.substring(5,10)}}
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="item.reportinfo.qi_job_error">
                    <p style="font-weight: 800; margin-bottom: 0; color: #e53935;">
                        Errors: <span>{{item.reportinfo.qi_job_error.length}}</span>
                    </p>
                    <div style="font-size: 16px; padding: 12px;">
                        <div *ngFor="let record of item.reportinfo.qi_job_error">
                            <p style="margin-bottom: 0.25em; font-weight: 800; color: #e53935; letter-spacing: -0.4px;">
                                {{record.street_address}}: {{record.error}}
                            </p>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- True Homes Permit Report -->
        <button type="button" class="collapsible" (click)="toggleContent(i)" *ngIf="item.reportinfo.updated">
            <span style="font-size: 20px; line-height: 3em; font-weight: 800; letter-spacing: -0.8px;">
                {{item.date_created.substring(0,10)}}
            </span>
            <span style="margin-left: 2em; font-size: 20px; line-height: 3em; font-weight: 200;">
                Addresses processed: {{item.reportinfo.updated.length + item.reportinfo.unchanged.length + item.reportinfo.address_not_found.length + item.reportinfo.skipped_rows.length + item.reportinfo.errors.length}}
            </span>
            <span style="float: right;font-size: 32px;">
                {{expanded[i] ? '-' : '+'}}
            </span>
        </button>
        <div class="content" [style.display]="expanded[i] ? 'block' : 'none'" *ngIf="item.reportinfo.updated">
            <div style="margin-top: 16px; font-size: 20px;">
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Updated: <span>{{item.reportinfo.updated.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.updated" style="margin-bottom: 0.75em;">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}
                        </p>
                        <div style="padding-left: 16px; font-weight: 400;">
                            <div *ngFor="let change of record.changes | keyvalue">
                                {{change.key}}: <span style="color: #999;">{{change.value.old}}</span> &rarr; <span>{{change.value.new}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Unchanged: <span>{{item.reportinfo.unchanged.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.unchanged">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Address Not Found: <span>{{item.reportinfo.address_not_found.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.address_not_found">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}<span *ngIf="record.community_name"> &mdash; {{record.community_name}}</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Skipped: <span>{{item.reportinfo.skipped_rows.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_rows">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}} <span style="color:#999;">({{record.reason}})</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;" *ngIf="item.reportinfo.provider_map_applied">
                    Provider Mapping Applied: <span>{{item.reportinfo.provider_map_applied.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;" *ngIf="item.reportinfo.provider_map_applied">
                    <div *ngFor="let record of item.reportinfo.provider_map_applied">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}} &mdash; {{record.field}}: <span style="color:#999;">{{record.csv_value}}</span> &rarr; <span>{{record.db_value}}</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Errors: <span>{{item.reportinfo.errors.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.errors">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] <span style="color:#c00;">{{record.error}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- True Homes Permit Report -->
        <button type="button" class="collapsible" (click)="toggleContent(i)" *ngIf="item.reportinfo.updated">
            <span style="font-size: 20px; line-height: 3em; font-weight: 800; letter-spacing: -0.8px;">
                {{item.date_created.substring(0,10)}}
            </span>
            <span style="margin-left: 2em; font-size: 20px; line-height: 3em; font-weight: 200;">
                Addresses processed: {{item.reportinfo.updated.length + item.reportinfo.unchanged.length + item.reportinfo.address_not_found.length + item.reportinfo.skipped_rows.length + item.reportinfo.errors.length}}
            </span>
            <span style="float: right;font-size: 32px;">
                {{expanded[i] ? '-' : '+'}}
            </span>
        </button>
        <div class="content" [style.display]="expanded[i] ? 'block' : 'none'" *ngIf="item.reportinfo.updated">
            <div style="margin-top: 16px; font-size: 20px;">
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Updated: <span>{{item.reportinfo.updated.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.updated" style="margin-bottom: 0.75em;">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}
                        </p>
                        <div style="padding-left: 16px; font-weight: 400;">
                            <div *ngFor="let change of record.changes | keyvalue">
                                {{change.key}}: <span style="color: #999;">{{change.value.old}}</span> &rarr; <span>{{change.value.new}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Unchanged: <span>{{item.reportinfo.unchanged.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.unchanged">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Address Not Found: <span>{{item.reportinfo.address_not_found.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.address_not_found">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}}<span *ngIf="record.community_name"> &mdash; {{record.community_name}}</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Skipped: <span>{{item.reportinfo.skipped_rows.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.skipped_rows">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}} <span style="color:#999;">({{record.reason}})</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;" *ngIf="item.reportinfo.provider_map_applied">
                    Provider Mapping Applied: <span>{{item.reportinfo.provider_map_applied.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;" *ngIf="item.reportinfo.provider_map_applied">
                    <div *ngFor="let record of item.reportinfo.provider_map_applied">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] {{record.address}} &mdash; {{record.field}}: <span style="color:#999;">{{record.csv_value}}</span> &rarr; <span>{{record.db_value}}</span>
                        </p>
                    </div>
                </div>
                <p style="font-weight: 800; margin-bottom: 0; color: #424242;">
                    Errors: <span>{{item.reportinfo.errors.length}}</span>
                </p>
                <div style="font-size: 16px; padding: 12px;">
                    <div *ngFor="let record of item.reportinfo.errors">
                        <p style="margin-bottom: 0.25em; font-weight: 800; color: #424224; letter-spacing: -0.4px;">
                            [{{record.sheet}}] <span style="color:#c00;">{{record.error}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</body>
</html>
